import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../components/site_layout'

const mapStateToProps = (state) => {
  return {
    site: state.site,
    sections: state.sections
  }
}

export default connect(mapStateToProps)(Page)


// WEBPACK FOOTER //
// ./app/javascript/app/site/containers/page.js